import React from "react";
import { ToolTipCompWrapper } from "./ToolTipComp.style";

interface ToolTipType {
  message?: string;
  top?: string;
  left?: string;
  right?: string;
  bottom?: string;
  zIndex?: number;
  width?: string;
  backgroundColor?: string;
  toolTipArrow?: string;
  children?: React.ReactNode;
  handleMouseLeave?: () => void;
  handleMouseEnter?: () => void;
}

const ToolTipComp = ({
  message,
  top,
  left,
  right,
  bottom,
  width,
  backgroundColor = "#1a7971",
  toolTipArrow,
  children,
  handleMouseEnter,
  handleMouseLeave,
  zIndex,
}: ToolTipType) => {
  return (
    <ToolTipCompWrapper
      width={width}
      top={top}
      left={left}
      right={right}
      bottom={bottom}
      backgroundColor={backgroundColor}
      toolTipArrow={toolTipArrow}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      zIndex={zIndex}
    >
      {children}
      {/* <WhiteCross cursor={true} /> */}
    </ToolTipCompWrapper>
  );
};

export default ToolTipComp;
